import { makeModuleApiInfoSelector } from "@client/content/selectors";
import { connectCustom } from "@client/lib/misc";
import { makeEntityDataSelector } from "@client/selectors";
import { type AppState, type EntityRef } from "@client/types";
import { localStateSelector, makeNetworkVolumeReportConfigSelector } from "../../selectors";
import { type MemberAffiliateDashboard } from "../../types";
import Component, { type ActionProps, type MapProps } from "./component";

type Props = EntityRef & {
  cycleEndDate: string;
  itemId: string;

  onBackClick: () => void;
};
const makeMapStateToProps = () => {
  const apiInfoSelector = makeModuleApiInfoSelector();
  const configSelector = makeNetworkVolumeReportConfigSelector();
  const entityDataSelector = makeEntityDataSelector<MemberAffiliateDashboard.ReportModuleItemData>();

  return (state: AppState, props: Props): MapProps => {
    const localState = localStateSelector(state, props);

    return {
      ...props,
      apiInfo: apiInfoSelector(state, { id: props.itemId, source: props.source }),
      config: configSelector(state, { id: props.itemId, source: props.source }),
      cycleOptions: localState.cycleOptions,
      reportId: entityDataSelector(state, { id: props.itemId, source: props.source }).id
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: Props): ActionProps => ({
  onBackClick: props.onBackClick
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
